import {
  Component,
  Inject,
  Input,
  OnInit
} from '@angular/core';
import { ChartsService } from '../../charts.service';
import { ThemeColor } from 'app/common/enums/theme-color.enum';
import { SkewChartComponent } from '../base-classes/skew-chart';
import { ColorThemeService } from 'app/common/services/color-theme.service';
import { getHttpParams } from '@iv/shared/utils';
import * as Redux from 'redux';
import { AppState } from '@iv/store/app.reducer';
import { AppStore } from '@iv/store/app.store';
import { PermissionTypes } from 'app/store/permissions/permissions.models';
import {PaymentWindowService} from '../../../payment-window.service';

@Component({
  selector: 'iv-live-time-skew-chart',
  templateUrl: './time-skew-chart.component.html',
  styleUrls: ['./time-skew-chart.component.scss']
})

export class TimeSkewChartComponent extends SkewChartComponent implements OnInit {

  constructor(
    private optionMonitorService: ChartsService,
    protected colorThemeService: ColorThemeService,
    @Inject(AppStore) protected readonly store: Redux.Store<AppState>,
    protected readonly paymentWindowService: PaymentWindowService
  ) {
    super(
      colorThemeService,
      store,
      paymentWindowService
    );
  }

  private dates: any[] = [];

  private _strike = '';
  private get strike(): string {
    return this._strike;
  }
  @Input()
  private set strike(value: string) {
    this._strike = value;
  }

  public ngOnInit(): void {
    super.ngOnInit();
  }

  protected getChartData(): void {
    this.noDataAvailable = false;
    if (this.instrument != null && this.strike != null) {

      this.optionMonitorService
        .getTimeSkewData(
          getHttpParams({
            [this.tabType === 'instrument' ? 'stockId' : 'underlyingId']:
              this.tabType === 'instrument' ? this.instrument.stockId : this.instrument.underlyingId,
            regionId: this.instrument.regionId.toString(),
            futExpDate: this.futureExpirationDate,
            strike: this.strike,
            isDelayed: (this.mode.toUpperCase() === PermissionTypes.DELAYED_STOCKS).toString()
          } as any),
          this.tabType,
          this.getPrefix()
        )
        .subscribe(data => {
          if (data.body) {
            data = data.body;
          }
          if (data.length > 0) {
            this.dates = [];
            this.ivCall = [];
            this.ivPut = [];
            this.noDataAvailable = false;
            data.forEach(row => {
              this.dates.push(row.daysToExp);
              this.ivCall.push(row.ivCallPercent);
              this.ivPut.push(row.ivPutPercent);
            }, this);
            const values = [...this.ivCall, ...this.ivPut];
            this.maxPercent = (Math.ceil(Math.max.apply(Math, values) * 10) / 10) + 1;
            const minP = (Math.floor(Math.min.apply(Math, values) * 10) / 10);
            this.minPercent = (minP === 0) ? 0 : (minP - 1);
            if (this.isChartInitialized) {
              this.reRenderChart();
            } else {
              this.renderChart();
              this.isChartInitialized = true;
            }
          } else {
            this.noDataAvailable = true;
          }
        });
    }
  }

  protected get getChartConfig(): Object {
    return {
      'type': 'line',
      'background-color': this.theme === ThemeColor.DARK ? '#242525' : '#fff',
      'utc': true,
      'plotarea': {
        'margin': '15px 25px 50px 75px',
        'background-color': this.backgroundColor
      },
      'scale-x': {
        'values': this.dates,
        'shadow': 0,
        'line-color': this.lineColor,
        'tick': {
          'line-color': this.lineColor
        },
        'guide': {
          'line-color': this.lineColor
        },
        'item': {
          'font-color': this.lineColor
        },
        'label': {
          'text': 'Maturity',
          'font-color': this.lineColor,
          'font-weight': 'normal'
        },
        'minor-ticks': 0
      },
      'scale-y': {
        'values': this.minPercent + ':' + this.maxPercent,
        'format': '%v %',
        'line-color': this.lineColor,
        'shadow': 0,
        'tick': {
          'line-color': this.lineColor
        },
        'guide': {
          'line-color': this.lineColor,
          'line-style': 'dashed'
        },
        'item': {
          'font-color': this.lineColor
        },
        'label': {
          'text': 'Implied volatility',
          'font-color': this.lineColor,
          'font-weight': 'normal'
        },
        'minor-ticks': 0,
        'thousands-separator': ','
      },
      'crosshair-x': {
        'line-color': this.lineColor,
        'plot-label': {
          'border-radius': '3px',
          'border-width': '1px',
          'border-color': this.lineColor,
          'padding': '10px',
          'font-weight': 'bold'
        },
        'scale-label': {
          'font-color': '#00baf0',
          'background-color': this.backgroundColor,
          'border-radius': '3px'
        }
      },
      'tooltip': {
        'visible': false
      },
      'plot': {
        'tooltip-text': '%t views: %v<br>%k',
        'shadow': 0,
        'line-width': '3px',
        'marker': {
          'type': 'circle',
          'size': 1
        },
        'hover-marker': {
          'type': 'circle',
          'size': 2,
          'border-width': '1px'
        }
      },
      'series': [
        {
          'values': this.ivPut,
          visible: this.putActive,
          'text': 'IV Put',
          'line-color': '#5F5BFF',
          'marker': {
            'background-color': '#5F5BFF',
            'border-width': 1,
            'shadow': 0,
            'border-color': '#6b68f2'
          }
        },
        {
          'values': this.ivCall,
          visible: this.callActive,
          'text': 'IV Call',
          'line-color': '#00AD80',
          'marker': {
            'background-color': '#00AD80',
            'border-width': 1,
            'shadow': 0,
            'border-color': '#00e8ac'
          }
        }
      ]
    };
  }
}
